import React from 'react';

import { Link } from '@opendoor/bricks-next';

interface LoginSectionProps {
  showLogin: boolean;
  onPress?: () => void;
}

export const LoginSection: React.FC<LoginSectionProps> = ({ showLogin, onPress }) => {
  if (!showLogin) return null;

  return (
    <Link
      href={'#'}
      onPress={onPress}
      fontWeight="$medium"
      analyticsName="cosmos-sign-in"
      aria-label="Sign in to your account"
      color="$contentPrimary"
    >
      Sign in
    </Link>
  );
};
